import { DCRecord } from "@/@types/lib/dataController";
import api from "@/lib/api";
import arrayBufferToBase64 from "@/lib/arrayBufferToBase64";
import { Clip } from "@/views/Operations/ObjectAnalysisImage";

export interface IImgService {
  getImage: (baseRecordPath: string, baseRecordId: number, imgNo: number, imgSize?: number, objExtent?: string) => Promise<any>;
  getObjImage: (baseRecordPath: string, baseRecordId: number, imgId: number, width: number, clip?: Clip) => Promise<any>;
  setObjImageFav: (baseRecordId: number, imageId: number, isFav: boolean) => Promise<any>;
  getRecordImageThumb: (baseRecordPath: string, baseRecordId: number, imageId: number) => Promise<any>;
  getRecordCrop: (baseRecordId: number, imageId: number, clip: Clip) => Promise<any>;
  setRecordCrop: (baseRecordId: number, cropOrdinal: number, data: any) => Promise<any>;
  deleteRecordCrop: (baseRecordId: number, cropOrdinal: number) => Promise<any>;
  getImageObjects: (imgId: number) => Promise<any>;
}

const imgService: IImgService = {
  getImage,
  getObjImage,
  setObjImageFav,
  getRecordImageThumb,
  getRecordCrop,
  setRecordCrop,
  deleteRecordCrop,
  getImageObjects,
};

function getImage(baseRecordPath: string, baseRecordId: number, imgNo: number, imgSize?: number, objExtent?: string): Promise<any> {
  const apiInstance = new api();
  const endsWithSlash = baseRecordPath.lastIndexOf('/') === baseRecordPath.length - 1 ? true : false;
  const url = `${baseRecordPath}${endsWithSlash ? "" : "/"}${baseRecordId}/images?img_number=${imgNo}&img_size=${imgSize ? imgSize : 190}&extent=${objExtent ? objExtent : ""}`;
  // const url = baseRecordPath + baseRecordId.toString() 
  //   + "/images?img_number=" + imgNo.toString()
  //   + "&img_size=" + (imgSize ? imgSize : 190).toString()
  //   + "&extent=" + (objExtent ? objExtent : "");

  return apiInstance.Call(url, "get");
}

function getObjImage(baseRecordPath: string, baseRecordId: number, imgId: number, width: number, clip?: Clip): Promise<any> {
  const apiInstance = new api();
  const endsWithSlash = baseRecordPath.lastIndexOf('/') === baseRecordPath.length - 1 ? true : false;
  const clipParam = clip ? `&clip=${clip.join(',')}` : null
  const url = `${baseRecordPath}${endsWithSlash ? "" : "/"}${baseRecordId}/images/${imgId}?width=${width || 0}${clipParam ? clipParam : ''}`;

  return apiInstance.Call(url, "get");
}

function setObjImageFav(baseRecordId: number, imageId: number, isFav: boolean) {
  const apiInstance = new api();
  const url = `operations/objekti/${baseRecordId}/images/${imageId}`;

  const data = { selected: isFav};

  return apiInstance.Call(url, "patch", data);
}

// Returns thumbnail for the record's image
function getRecordImageThumb(baseRecordPath: string, baseRecordId: number, imageId: number) {
  const apiInstance = new api();

  const endsWithSlash = baseRecordPath.lastIndexOf('/') === baseRecordPath.length - 1 ? true : false;
  const url = `${baseRecordPath}${endsWithSlash ? "" : "/"}${baseRecordId}/images/${imageId}/thumb`;

  return apiInstance.Download(url).then((resp) => {
    if (resp.success && resp.data) {
      return resp.data.then((data: Blob) => {
        return data.arrayBuffer().then((arrBuffer: ArrayBuffer) => {
          return arrayBufferToBase64(arrBuffer);
        })
      });
    } else {
      return Promise.reject(null);
    }
  })
}

function getRecordCrop(baseRecordId: number, imageId: number, clip: Clip) {
  const apiInstance = new api();

  const width = 200;
  const [x, y, w, h] = clip;
  const corrected = [x, y, x + w, y + h];
  const url = `operations/objekti/${baseRecordId}/images/${imageId}?width=${width}&clip=${corrected.join(',')}`;

  return apiInstance.Call(url, "get");
}

function setRecordCrop(baseRecordId: number, cropOrdinal: number, data: any) {
  const apiInstance = new api();
  const url = `operations/objekti/${baseRecordId}`;

  const [bx, by, ex, ey] = data.clip;
  const w = ex - bx;
  const h = ey - by;
  const corrected = [bx, by, w, h];

  let d = {} as DCRecord;
  if (cropOrdinal === 1) {
    d['foto_1'] = data.imageId;
    d['foto_1_extent'] = corrected.join(',');
  } else if (cropOrdinal === 2) {
    d["foto_2"] = data.imageId;
    d["foto_2_extent"] = corrected.join(',');
  }
  
  return apiInstance.Call(url, "patch", d);
}

function deleteRecordCrop(baseRecordId: number, cropOrdinal: number) {
  const apiInstance = new api();
  const url = `operations/objekti/${baseRecordId}`;

  let d = {} as DCRecord;
  if (cropOrdinal === 1) {
    d['foto_1'] = null;
    d['foto_1_extent'] = null;
  } else if (cropOrdinal === 2) {
    d["foto_2"] = null;
    d["foto_2_extent"] = null;
  }
  return apiInstance.Call(url, "patch", d);
}

function getImageObjects(imageId: number) {
  const apiInstance = new api();
  const url = `operations/images/${imageId}/objekti`;
  return apiInstance.Call(url, "get");  
}

export default imgService;